import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

import { observable, makeObservable, runInAction, computed } from "mobx";
import { ORDER_TYPES } from "@dp/common";
var LocationModel = (_class = /*#__PURE__*/function () {
  function LocationModel() {
    _classCallCheck(this, LocationModel);

    _initializerDefineProperty(this, "_location", _descriptor, this);

    _initializerDefineProperty(this, "_locationDateTime", _descriptor2, this);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor3, this);

    _initializerDefineProperty(this, "_deliveryAddress", _descriptor4, this);

    makeObservable(this);
    this.location = {
      restaurantName: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      phoneNumber: "",
      lat: "",
      lng: ""
    };
    this.locationDateTime = {
      actualPickupDateTime: null,
      datePickerDate: null,
      selectedTime: "",
      timesData: "",
      asap: "",
      specificDateTime: ""
    };
  }

  _createClass(LocationModel, [{
    key: "location",
    get: function get() {
      return this._location;
    },
    set: function set(_location) {
      var _this = this;

      runInAction(function () {
        _this._location = _location;
      });
    }
  }, {
    key: "deliveryAddress",
    get: function get() {
      return this._deliveryAddress;
    },
    set: function set(_deliveryAddress) {
      var _this2 = this;

      runInAction(function () {
        _this2._deliveryAddress = _deliveryAddress;
      });
    }
  }, {
    key: "locationDateTime",
    get: function get() {
      return this._locationDateTime;
    },
    set: function set(_locationDateTime) {
      var _this3 = this;

      runInAction(function () {
        _this3._locationDateTime = _locationDateTime;
      });
    }
  }, {
    key: "isCateringDelivery",
    get: function get() {
      var _this$_sessionDetails, _this$_sessionDetails2;

      return (this === null || this === void 0 ? void 0 : (_this$_sessionDetails = this._sessionDetails) === null || _this$_sessionDetails === void 0 ? void 0 : (_this$_sessionDetails2 = _this$_sessionDetails.orderContext) === null || _this$_sessionDetails2 === void 0 ? void 0 : _this$_sessionDetails2.orderTypeValue) === ORDER_TYPES.CATERING_DELIVERY;
    }
  }, {
    key: "sessionDetails",
    get: function get() {
      return this._sessionDetails;
    },
    set: function set(_sessionDetails) {
      var _this4 = this;

      runInAction(function () {
        _this4._sessionDetails = _sessionDetails;
      });
    }
  }]);

  return LocationModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_location", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_locationDateTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_deliveryAddress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "location", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "location"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationDateTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationDateTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCateringDelivery", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCateringDelivery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sessionDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sessionDetails"), _class.prototype)), _class);
export { LocationModel as default };